module.exports = __webpack_public_path__ + "assets/media/client_training_20sec.2d2c0988.mp4";